// Serena growth-ring stage scrubber. Reads its stage data from a data-stages
// JSON attribute (rendered server-side from the section's blocks) rather than
// hardcoding copy in JS, so merchants can edit stages in the theme editor.
(function () {
  'use strict';

  document.querySelectorAll('[data-growth-ring]').forEach(function (root) {
    var stages;
    try { stages = JSON.parse(root.dataset.stages); } catch (e) { return; }
    if (!stages || !stages.length) return;

    var ageEl = root.querySelector('[data-stage-age]');
    var titleEl = root.querySelector('[data-stage-title]');
    var bodyEl = root.querySelector('[data-stage-body]');
    var iconEl = root.querySelector('[data-stage-icon]');
    var photoEl = root.querySelector('[data-stage-photo]');
    var fillEl = root.querySelector('[data-stage-fill]');
    var counterEl = root.querySelector('[data-stage-counter]');
    var stops = Array.prototype.slice.call(root.querySelectorAll('[data-stage-stops] .stage-stop'));
    var rings = Array.prototype.slice.call(root.querySelectorAll('[data-ring]'));

    function setStage(i) {
      var s = stages[i];
      if (ageEl) ageEl.textContent = s.age;
      if (titleEl) titleEl.textContent = s.title;
      if (bodyEl) bodyEl.textContent = s.body;
      if (s.image && photoEl) {
        photoEl.src = s.image;
        photoEl.alt = s.title || '';
        photoEl.hidden = false;
        if (iconEl) iconEl.hidden = true;
      } else {
        if (photoEl) photoEl.hidden = true;
        if (iconEl) { iconEl.hidden = false; iconEl.innerHTML = s.icon; }
      }
      if (fillEl) fillEl.style.width = (i / (stages.length - 1) * 100) + '%';
      if (counterEl) counterEl.textContent = (i + 1) + ' / ' + stages.length;
      stops.forEach(function (el, idx) { el.classList.toggle('active', idx === i); });
      // Each ring lights up as its stage is reached; the ring for the current
      // stage glows brightest and older rings fade a step further with each
      // stage you advance, so growth actually reads instead of every active
      // ring snapping to the same brightness at once.
      rings.forEach(function (el, idx) {
        var isActive = idx <= i;
        el.classList.toggle('active', isActive);
        if (isActive) {
          var age = i - idx;
          el.style.opacity = Math.max(0.3, 1 - age * 0.22);
        } else {
          el.style.opacity = '';
        }
      });
    }

    stops.forEach(function (el) {
      el.addEventListener('click', function () { setStage(parseInt(el.dataset.i, 10)); });
    });

    var track = root.querySelector('.stage-line');
    var dragging = false;
    function posToStage(clientX) {
      var r = track.getBoundingClientRect();
      var pct = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
      return Math.round(pct * (stages.length - 1));
    }
    if (track) {
      track.addEventListener('pointerdown', function (e) { dragging = true; setStage(posToStage(e.clientX)); });
      window.addEventListener('pointermove', function (e) { if (dragging) setStage(posToStage(e.clientX)); });
      window.addEventListener('pointerup', function () { dragging = false; });
    }

    setStage(0);
  });
})();
